import React, { memo } from 'react';
import LcLogo from 'assets/lacentrale-logo.png';
import { config } from 'config';
import styles from './Header.module.scss';

const Header = memo(() => {
  return (
    <header className={styles.header}>
      <a href={config.URL_LACENTRALE}>
        <img src={LcLogo} width={158} height={36} alt="La Centrale.fr, 1er site de véhicule d´occasion" />
      </a>
      <h1>
        <span>Vendre son véhicule</span>
      </h1>
    </header>
  );
});

Header.displayName = 'Header';

export { Header };
